<template>
  <footer
    class="relative sm:fixed bottom-0 left-0 w-full gap-5 items-center px-5 flex flex-wrap py-3 md:justify-between justify-center"
  ></footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  computed: {
    ...mapGetters(["activeNetwork"]),
  },

  methods: {},
};
</script>
